import React, { useContext, useMemo } from 'react';
import { RelayEnvironmentProvider as DefaultProvider, ReactRelayContext, useRelayEnvironment } from 'react-relay';
import { Environment } from 'relay-runtime';
import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
var environment = new Environment(getDefaultRelayEnvironmentConfig({}));
export var RelayEnvironmentProvider = function RelayEnvironmentProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(DefaultProvider, {
    environment: environment
  }, children);
};
export var ConditionalRelayEnvironmentProvider = function ConditionalRelayEnvironmentProvider(_ref2) {
  var children = _ref2.children;
  var isRelayPresent = useContext(ReactRelayContext);
  if (isRelayPresent) {
    return children;
  }
  return /*#__PURE__*/React.createElement(RelayEnvironmentProvider, null, children);
};
export function useRelayEnvironmentProvider() {
  var environment = useRelayEnvironment();
  return useMemo(function () {
    return {
      getEnvironment: function getEnvironment() {
        return environment;
      }
    };
  }, [environment]);
}